module.exports = __webpack_public_path__ + "static/media/thin_x.d86f4e8c.svg";